<template>
  <v-container fluid>
    <v-row class="d-flex flex-row">
      <v-col cols="12">
        <FormPersonalDetail
          :data="personalDetail"
          :loading="isFormLoading"
          :disabled="isMutationLoading"
          @submit="onFormSubmit"
          @delete-detail="onDeleteDetail"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmDetailDelete" confirmText="Удалить" />
  </v-container>
</template>

<script>
// Components
import ConfirmationDialog from '@/components/confirmation-dialog'
import FormPersonalDetail from './form/FormPersonalDetail'
// GQL
import personalDetailQuery from '@/services/gql/types/PersonalDetail/queries/personalDetail.graphql'
import deletePersonalDetailMutation from '@/services/gql/types/PersonalDetail/mutations/deletePersonalDetail.graphql'
import updatePersonalDetailMutation from '@/services/gql/types/PersonalDetail/mutations/updatePersonalDetail.graphql'

export default {
  name: 'PagePersonalDetail',
  props: {
    id: {
      type: [Number, String],
      default: null
    }
  },
  data () {
    return {
      personalDetail: {}
    }
  },
  components: {
    FormPersonalDetail,
    ConfirmationDialog
  },
  computed: {
    isFormLoading () {
      return this.$apollo.queries.personalDetail.loading
    },
    isMutationLoading () {
      return this.$async.updateDetail.$pending ||
        this.$async.deleteDetail.$pending
    }
  },
  methods: {
    async onFormSubmit (formData) {
      try {
        await this.$async.updateDetail.$perform({
          id: this.id,
          data: formData
        })
        this.$successMsg('Анкета успешно сохранена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при сохранении анкеты пользователя')
      }
    },
    async onDeleteDetail () {
      try {
        if (await this.$refs.confirmDetailDelete.open()) {
          await this.$async.deleteDetail.$perform({ id: this.id })
          this.$successMsg('Анкета успешно удалена')
        }
      } catch (e) {
        if (!e.cancel) {
          this.$handleApiError(e.graphQLErrors, `Ошибка при удалении анкеты с ID ${this.id}`)
        }
      } finally {
        await this.$router.push({ name: 'page-personal-details' })
      }
    }
  },
  apollo: {
    personalDetail: {
      query: personalDetailQuery,
      fetchPolicy: 'network-only',
      skip () {
        return !this.id
      },
      variables () {
        return {
          where: {
            id: this.id
          }
        }
      }
    }
  },
  async: {
    deleteDetail (variables) {
      return this.$apollo.mutate({
        mutation: deletePersonalDetailMutation,
        variables
      })
    },
    updateDetail (variables) {
      return this.$apollo.mutate({
        mutation: updatePersonalDetailMutation,
        variables
      })
    }
  }
}
</script>
